package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_file_data_di_FileModule : Module get() = module {
	single() { _ -> com.essntl.features.file.data.repository.FileRepositoryImpl(supabase=get()) } bind(com.essntl.features.file.domain.repository.FileRepository::class)
	single() { _ -> com.essntl.features.file.data.supabase.FileSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.file.data.supabase.FileSupabaseDataSource::class)
}
public val com.essntl.features.file.data.di.FileModule.module : org.koin.core.module.Module get() = com_essntl_features_file_data_di_FileModule
